import { useState } from "react";
import { useInterval } from "usehooks-ts";
import { Loader } from "../common/Loader";
import { Empty } from "../layout/EmptyLayout";
import "./PageLoading.css";

const loadingMessages = [
	"Waking up Moxie",
	"Tuning your brand voice",
	"Getting everything ready",
	"Loading your marketing hub",
	"Almost there",
];

export const PageLoading = () => {
	const [message] = useState(
		loadingMessages[Math.floor(Math.random() * loadingMessages.length)],
	);
	const [dots, setDots] = useState(0);

	useInterval(() => {
		setDots((x) => (x >= 3 ? 0 : x + 1));
	}, 500);

	const dotsString = ".".repeat(dots);
	const title = `${message}${dotsString}`;

	return (
		<Empty.Container>
			<title>{title}</title>
			<div className="page-loading">
				<div className="page-loading-glow" aria-hidden />
				<Loader size="lg" />
				<p className="page-loading-eyebrow">Moxie</p>
				<p className="page-loading-title">
					{message}
					<span className="page-loading-dots" aria-hidden>
						{dotsString}
					</span>
				</p>
			</div>
		</Empty.Container>
	);
};
